import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
const logo = process.env.PUBLIC_URL + '/images/logo.jpeg'

const Welcome = () => {
  const { isAuthenticated, isSuperuser, userGroups, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading) {
      if (isAuthenticated) {
        // Manager, Admin, or Superuser go to surveys, others go to operations
        const allowedGroups = ['Manager', 'Admin']
        const hasAccess = isSuperuser || userGroups.some(group => allowedGroups.includes(group))
        
        if (hasAccess) {
          navigate('/surveys', { replace: true })
        } else {
          navigate('/operations', { replace: true })
        }
      } else {
        navigate('/login', { replace: true })
      }
    }
  }, [isAuthenticated, isSuperuser, userGroups, loading, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-jnj-primary to-jnj-secondary">
      <div className="text-center">
        <img src={logo} alt="JNJ Logo" className="mx-auto h-32 mb-8" />
        <h1 className="text-4xl font-bold text-white mb-4">Welcome to JNJ Survey Management</h1>
        <p className="text-white/80 text-lg">Loading...</p>
      </div>
    </div>
  )
}

export default Welcome

